"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_registry_1 = require("react-registry");
var generate_1 = require("../generate");
var TypeUtils_1 = require("../util/TypeUtils");
var FieldWrapper = (function () {
    function FieldWrapper(_a) {
        var dataType = _a.dataType, uiWidget = _a.uiWidget, uiField = _a.uiField, _b = _a.label, label = _b === void 0 ? true : _b, arrayType = _a.arrayType;
        this.dataType = dataType;
        this.uiWidget = uiWidget;
        this.uiField = uiField;
        this.label = label;
        this.arrayType = arrayType;
    }
    FieldWrapper.prototype.getDataType = function () {
        return this.dataType;
    };
    FieldWrapper.prototype.getUiWidget = function () {
        return this.uiWidget;
    };
    FieldWrapper.prototype.getUiField = function () {
        return this.uiField;
    };
    FieldWrapper.prototype.isLabel = function () {
        return this.label;
    };
    FieldWrapper.prototype.isArray = function () {
        return TypeUtils_1.iDef(this.arrayType);
    };
    FieldWrapper.prototype.getArrayType = function () {
        return this.arrayType;
    };
    return FieldWrapper;
}());
exports.default = FieldWrapper;
function registerExternal(type, wrapper, conditions) {
    register(type, wrapper, TypeUtils_1.iDef(conditions) ? __assign({}, conditions, generate_1.providerConditions) : generate_1.providerConditions);
}
exports.registerExternal = registerExternal;
function register(type, wrapper, conditions) {
    react_registry_1.Registry.register(wrapper, { id: type, registry: "decorator-form", conditions: conditions });
}
exports.register = register;
//# sourceMappingURL=FieldWrapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/decorator-form/dist/fields/FieldWrapper.js
// module id = 792
// module chunks = 0